import { Link, useLocation } from "react-router-dom";
import { Home, Wrench, BookOpen, Shield, Search } from "lucide-react";
import { cn } from "@/lib/utils";

interface MobileBottomBarProps {
  onCommandOpen: () => void;
}

const items = [
  { icon: Home, label: "Inicio", to: "/" },
  { icon: Wrench, label: "Arsenal", to: "/arsenal" },
  { icon: BookOpen, label: "Knowledge", to: "/knowledge" },
  { icon: Shield, label: "Awareness", to: "/conciencia" },
];

export const MobileBottomBar: React.FC<MobileBottomBarProps> = ({ onCommandOpen }) => {
  const { pathname } = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-border bg-surface-0/95 backdrop-blur-xl pb-[env(safe-area-inset-bottom)]">
      <ul className="grid grid-cols-5 h-14">
        {items.slice(0, 2).map((it) => (
          <BottomItem key={it.to} {...it} active={isActive(pathname, it.to)} />
        ))}
        {/* Center command */}
        <li>
          <button
            onClick={onCommandOpen}
            className="w-full h-full flex flex-col items-center justify-center gap-0.5 text-primary group"
            aria-label="Command palette"
          >
            <div className="w-9 h-9 -mt-4 border border-primary bg-surface-1 flex items-center justify-center clip-corner-sm shadow-glow group-active:bg-primary/10">
              <Search className="w-4 h-4" />
            </div>
            <span className="font-mono text-[9px] uppercase tracking-[0.18em]">cmd</span>
          </button>
        </li>
        {items.slice(2).map((it) => (
          <BottomItem key={it.to} {...it} active={isActive(pathname, it.to)} />
        ))}
      </ul>
    </nav>
  );
};

function isActive(pathname: string, to: string) {
  if (to === "/") return pathname === "/";
  return pathname === to || pathname.startsWith(to + "/");
}

const BottomItem: React.FC<{ icon: any; label: string; to: string; active: boolean }> = ({ icon: Icon, label, to, active }) => (
  <li>
    <Link
      to={to}
      className={cn(
        "h-full w-full flex flex-col items-center justify-center gap-1 transition-colors relative",
        active ? "text-primary" : "text-muted-foreground hover:text-foreground",
      )}
    >
      {active && <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-[2px] bg-primary" />}
      <Icon className="w-4 h-4" strokeWidth={1.6} />
      <span className="font-mono text-[9px] uppercase tracking-[0.18em]">{label}</span>
    </Link>
  </li>
);